import { render, staticRenderFns } from "./WhyThoseOutfits.vue?vue&type=template&id=5b5b4f09&scoped=true&lang=pug&"
import script from "./WhyThoseOutfits.vue?vue&type=script&lang=js&"
export * from "./WhyThoseOutfits.vue?vue&type=script&lang=js&"
import style0 from "./WhyThoseOutfits.vue?vue&type=style&index=0&id=5b5b4f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b4f09",
  null
  
)

export default component.exports